import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col, Form, Button } from 'antd'
import OtpInput from 'react-otp-input'

import { BUTTONS, LOGIN_PAGE } from '../../../../../../constants/constants'
import { useActions } from '../../../../../hooks/useActions'
import CustomNotifocation from 'components/CustomNotification'

import Timer from 'components/Timer'

import '../sidebar.scss'
import '../MessageInput/index.scss'
import './index.scss'
import { changeRoute, changeTab, verifyAuthData, verifyPasswordChangeData, removeNotification, getSmsAgain } from 'store/actions/login'
import { secureLocalStorageGet } from '../../../../../helpers'
import { useTranslation } from 'react-i18next'

const SmsInput: React.FC = ({ errorMessage, notifyData, pswStore }) => {
  const {t} = useTranslation();
  const { verifyAuthData,removeNotification, changeRoute, changeTab, verifyPasswordChangeData, getSmsAgain } = useActions()
  const [form] = Form.useForm()
  const history = useHistory()
  const [value, setValue] = useState([])
  const [smsClicked, setClicked] = useState(false)

  const handleChangeRoute = () => {
    localStorage.clear()
    changeRoute(0)
  }

  const handleInput = () => {
    if (!localStorage.getItem('verify')) {
      verifyAuthData(value, history)
    } else {
      let verifyData = {
        userName: secureLocalStorageGet("username"),
        verfication: value
      }
      verifyPasswordChangeData(verifyData, history)
    }
  }

  const handleValue = (value: any) => {
    setValue(value)
  }
  const sendSmsCode = () => {
    setClicked(false)
    getSmsAgain(pswStore)
  }
  useEffect(
    () => {
      let timer1 = setInterval(() => setClicked(true), 20 * 1000);
      return () => {
        clearInterval(timer1);
      }
    },
    [smsClicked]
  );

  const resetForm = () => {
    changeRoute(0)
    changeTab(1)
  }
  const closeNotification = () => {
    removeNotification()
 }
  return (
    <Row>
      {errorMessage && notifyData && <CustomNotifocation message={errorMessage[0].MESSAGE} />}
      <Col className="login-form" style={{ padding: '0px 15px' }}>
        <h3>{t(LOGIN_PAGE.ENTER_SMS)}</h3>
        <Form
          form={form}
          onSubmit={(e: any) => e.preventDefault()}
          onFinish={handleInput}
          onBlur={closeNotification}
          autoComplete="off"
          className="message-input-form sms-input--form"
        >
          <OtpInput
            value={value}
            onChange={handleValue}
            numInputs={5}
            shouldAutoFocus={true}
            inputStyle='otpInput'
            isInputNum={true}
            className='message-input-form__input'
          />
          <ul className="message-form__details">
            <li>
              {value
                ? <Timer timerEnd={resetForm} />
                : <span>00:00</span>}
            </li>
            <li>
              <a onClick={sendSmsCode} className={(smsClicked) ? 'active' : 'disabled'}>{t(LOGIN_PAGE.DETAILS_DATA)}</a>

            </li>
          </ul>
          <div className="login-form__buttons">
            <Row>
              <Button size={'large'} className="prev" onClick={handleChangeRoute}>
                {BUTTONS.BACK_BUTTON}
              </Button>
              <Button
                size={'large'}
                className="next blue"
                htmlType="submit"
              >
                {BUTTONS.NEXT_BUTTON}
              </Button>
            </Row>
          </div>
        </Form>
      </Col>
    </Row>
  )
}

const mapDispatchToProps = { verifyAuthData,removeNotification, changeRoute, changeTab, verifyPasswordChangeData, getSmsAgain }

const mapStateToProps = (state: any) => ({
  notifyData: state.googleAuth.notify,
  errorMessage: state.googleAuth.error ? state.googleAuth.error.messages : ''
})
export default connect(mapStateToProps, mapDispatchToProps)(SmsInput)
